import React from 'react';
import Container from 'react-bootstrap/Container';
import NavbarComponent from '../Components/NavbarComponent';
import LowestNavbar from '../Components/LowestNavbar';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

const visions = [
  "Vision 1",
  "Vision 2",
  "Vision 3",
  "Vision 4",
  "Vision 5",
  "Vision 6",
  "Vision 7",
  "Vision 8",
  "Vision 9",
  "Vision 10",
  "Vision 11",
  "Vision 12",
];

const showCards = false; // 🔁 Toggle this to true to display the vision cards

function Vision() {
  return (
    <div>
      <NavbarComponent />
      <h1 className="vision-head mx-3 my-4">Vision</h1>

      {showCards ? (
        <Container className="d-flex flex-wrap justify-content-center">
          {visions.map((title, idx) => (
            <Card key={idx} className="text-center mx-2 my-3" style={{ width: '18rem' }}>
              <Card.Header>Project {idx + 1}</Card.Header>
              <Card.Body>
                <Card.Title>{title}</Card.Title>
                <Card.Text>
                  When you change the way you look at things, the things you look at change.
                </Card.Text>
                <Button variant="primary">In Progress</Button>
              </Card.Body>
              <Card.Footer className="text-muted">2 days ago</Card.Footer>
            </Card>
          ))}
        </Container>
      ) : (
        <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light px-3">
  <div className="text-center">
    <h3 style={{ fontWeight: '700', fontSize: '2rem', color: '#333' }}>
      🚧 Coming soon...
    </h3>
    <p style={{ fontSize: '1.1rem', color: '#555', maxWidth: '600px', margin: '0 auto' }}>
      This section is under vision & development. Stay tuned!
    </p>
  </div>
</div>



      )}

      <LowestNavbar />
    </div>
  );
}

export default Vision;
